import React, { Component } from 'react';
import './LoadingTransition.scss';

const loadingTransitionHOC = (WrappedComponent) => {
    class LoadingTransitionHOC extends Component {
        constructor(props) {
            super(props);
            this.childRef = React.createRef();
        }

        componentDidMount() {
            const { current } = this.childRef;
            if (current) {
                current.classList.add('loading-transition-container');
                setTimeout(() => { current.classList.add('enable-loading-transition'); }, 0);
            }
        }

        render() {
            return <WrappedComponent {...this.props} childRef={this.childRef} />;
        }
    }
    return LoadingTransitionHOC;
};

export default loadingTransitionHOC;
